const configS3 = (bucketName, dirName) => {
  return {
    bucketName: bucketName,
    dirName: dirName || "data" /* optional */,
    region: process.env.VUE_APP_S3_REGION,
    accessKeyId: process.env.VUE_APP_S3_KEYID,
    secretAccessKey: process.env.VUE_APP_S3_ACCESSKEY,
  };
};

export default configS3;
